import PageRouter from './PageRouter';

export default PageRouter;